import * as xlsx from "xlsx";
import { saveAs } from "file-saver";

export const exportToExcel = (sheets, fileName) => {
  debugger;
  const workbook = {
    SheetNames: [],
    Sheets: {},
  };

  sheets.forEach((sheet) => {
    const worksheet = xlsx.utils.json_to_sheet(sheet.data || []);
    workbook.Sheets[sheet.sheetName] = worksheet;
    workbook.SheetNames.push(sheet.sheetName);
  });

  const excelBuffer = xlsx.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8", // Added charset for robustness
  });

  saveAs(blob, `${fileName}.xlsx`);
};
